<template>
  <div class="info" v-if="element.type === 'phone'">
    <div class="info__title" :style="{color: $store.registratorCaptionColor}">
      {{ element.kiosk_title[$store.activeLanguage] }}
    </div>
    <PhoneInput
      :value="phoneNumber"
      @input="updatePhoneInput"
      class="info__input"
      type="tel"
      inputmode="tel"
      autocomplete="tel"
      name="phone"
      :maxlength="'22'"
      :style="{color: $store.registratorCaptionColor}"
    />
  </div>
  <div class="info" v-else>
    <div class="info__title" :style="{color: $store.registratorCaptionColor}">
      {{ element.kiosk_title[$store.activeLanguage] }}
    </div>
    <input
      class="info__input"
      :type="type"
      :class="{ 'info__input_focused': isActive }"
      :value="value"
      :style="{color: $store.registratorCaptionColor}"
      @input="$emit('input', $event.target.value)"
      @keypress="validateInput"
    />
  </div>
</template>

<script>
import PhoneInput from './phone-input/PhoneInput';

export default {
  name: 'GroupParamMobileElement',
  props: {
    element: {type: Object, required: true},
    isActive: {type: Boolean, required: false},
    value: { type: String, default: '' },
  },
  components: {
    PhoneInput,
  },
  data() {
    return {
      phoneNumber: this.value,
      dialCode: '',
    }
  },
  computed: {
    type() {
      return this.element.type === 'number' ? 'number' : 'text';
    },
  },
  watch: {
    phoneNumber: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      immediate: true
    },
    value(newValue) {
      if (newValue !== this.phoneNumber) {
        this.phoneNumber = newValue;
      }
    }
  },
  methods: {
    updatePhoneInput(value) {
      this.phoneNumber = value.replace(/\s+/g, '');
    },
    validateInput (event)  {   
      if (this.element.type === 'number') {
        const forbiddenKeys = ['e', 'E', '+', '-', ',', '.']
        if (forbiddenKeys.includes(event.key)) {
          event.preventDefault()
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-bottom: 5px;

  &__title {
    margin-bottom: 10px;
    margin-left: 10px;
    font-size: 34px;
  }

  &__input {
    display: inline-block;
    margin-bottom: 30px;
    box-sizing: border-box;
    padding: 9px 24px;
    font-size: 42px;
    border-radius: 180px;
    height: 100px;
    border: none;
    outline: none;
    caret-color: black;
    background: rgba(239, 239, 244, 0.45);
    box-shadow: 0 33px 38px rgba(0, 0, 0, 0.0314074), 0 12px 12px rgba(0, 0, 0, 0.05), 0 3px 3px rgba(0, 0, 0, 0.08);
    text-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
  }
}
</style>
